import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import MfaVerify from "./pages/auth/MfaVerify";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Apps from "./pages/Apps";
import Agents from "./pages/Agents";
import Extraction from "./pages/Extraction";
import Inbox from "./pages/Inbox";
import Parse from "./pages/Parse";
import EInvoice from "./pages/EInvoice";
import VatReturns from "./pages/VatReturns";
import Scenarios from "./pages/Scenarios";
import StatusTrace from "./pages/StatusTrace";
import BatchApproval from "./pages/BatchApproval";
import Reconciliation from "./pages/Reconciliation";
import Settings from "./pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public auth routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/mfa" element={<MfaVerify />} />

            {/* Protected app */}
            <Route path="/a" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="profile" element={<Profile />} />
              <Route path="apps" element={<Apps />} />
              <Route path="agents" element={<Agents />} />
              <Route path="extraction" element={<Extraction />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="parse" element={<Parse />} />
              <Route path="e-invoice" element={<EInvoice />} />
              <Route path="vat-returns" element={<VatReturns />} />
              <Route path="scenarios" element={<Scenarios />} />
              <Route path="status" element={<StatusTrace />} />
              <Route path="batch" element={<BatchApproval />} />
              <Route path="reconciliation" element={<Reconciliation />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            <Route path="/" element={<Navigate to="/a/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/a/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
